import { Box, Button, Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

interface IProps {
  slug?: string;
  businessId: number | null;
}

export const OnboardingComplete: React.FC<IProps> = ({ slug, businessId }) => {
  const navigate = useNavigate();

  const handleVerPagina = () => {
    if (slug) navigate(`/${slug}`);
  };

  const handleIrPainel = () => {
    navigate('/business', { state: { businessId } });
  };

  const handleConfigurarWhatsApp = () => {
    navigate('/business', { state: { businessId, page: 7, subPage: 1 } }); // TAB_WHATSAPP = 7, subPage IA = 1
  };

  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="100vh" gap={2}>
      <Typography variant="h3" sx={{ mb: 2 }}>🎉</Typography>
      <Typography variant="h5" fontWeight={700} gutterBottom>
        Cadastro concluído!
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
        Seu estabelecimento está pronto para receber agendamentos.
      </Typography>
      <Grid container spacing={2} justifyContent="center">
        <Grid item>
          <Button variant="contained" size="large" onClick={handleVerPagina}>
            Ver página pública
          </Button>
        </Grid>
        <Grid item>
          <Button variant="outlined" size="large" onClick={handleConfigurarWhatsApp}>
            Configurar WhatsApp
          </Button>
        </Grid>
        <Grid item>
          <Button variant="text" size="large" onClick={handleIrPainel}>
            Ir para o painel
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};
